import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import Cookies from "js-cookie";

const COOKIE_KEY = "top-banner";

export default function TopBanner() {
  const { t } = useTranslation();
  const [disabled, setDisabled] = useState(true);
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (!Cookies.get(COOKIE_KEY)) setDisabled(false);
  }, []);

  function close() {
    setDisabled(true);
    Cookies.set(COOKIE_KEY, "true");
  }

  if (disabled) return null;

  return (
    <div className={`top-banner ${opened ? "active" : ""}`}>
      <div className="container">
        <div className={"top-banner-head"}>
          <div
            onClick={() => setOpened(!opened)}
            className={"top-banner-headText"}
            dangerouslySetInnerHTML={{ __html: t("topBanner.head") }}
          />
          <div className={"top-banner-close"} onClick={close}>
            &times;
          </div>
        </div>
        <div className={"top-banner-body"}>
          <div
            className={"top-banner-bodyText"}
            dangerouslySetInnerHTML={{ __html: t("topBanner.body") }}
          />
        </div>
      </div>
    </div>
  );
}
